module.exports = {
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "portfolio"

  siteTitle: 'ムチでメモ', // Navigation and Site Title
  siteTitleAlt: 'ムチでメモ - カナダ･バンクーバーで、M/Mロマンスとか、BLとか', // Alternative Site title for SEO
  siteTitleManifest: 'カナダ･バンクーバーで、M/Mロマンスとか、BLとか',
  siteUrl: 'https://muchimemo.com', // Domain of your site. No trailing slash!
  siteLanguage: 'ja', // Language Tag on <html> element
  siteHeadline: 'Writing and publishing content', // Headline for schema.org JSONLD
  siteBanner: '/img/banner.jpg', // Your image for og:image tag. You can find it in the /static folder
  favicon: 'src/favicon.png', // Your image for favicons. You can find it in the /src folder
  siteDescription:
    'カナダ、バンクーバーで暮らす、鞭が似合うとか、壇蜜に似てるとか言われるジーナが、ただただ日々思うことを垂れ流しています。M/Mロマンス小説とBLマンガが日々の糧。', // Your site description
  author: 'ジーナ', // Author for schemaORGJSONLD
  siteLogo: '/img/logo.png', // Image for schemaORGJSONLD

  siteFBAppID: '560994258050661', // Facebook App ID - Optional
  userTwitter: '@muchimemo', // Twitter Username - Optional
  twitterScreenName: 'muchimemo',
  ogSiteName: 'ムチでメモ', // Facebook Site Name - Optional
  ogLanguage: 'ja_JP', // Facebook Language
  googleAnalyticsID: 'G-WW3JCQC5ES',

  // Manifest and Progress color
  // See: https://developers.google.com/web/fundamentals/web-app-manifest/
  themeColor: '#47a89c',
  backgroundColor: '#2b2e3c',
}
